<script>
  import Container from '@/library/container/full-centre.svelte';
  import LgTextBlock from '@/library/content/lg-text-block.svelte';
  import SmTextBlock from '@/library/content/sm-text-block.svelte';

  import Grid from '@/library/grid/basic-31.svelte';
  import Logo from '@/library/logo/mark-sm.svelte';
  

  export let service;

  // let layout = service.layout;
  // let pretext = service.content.pretext;
  let context = service.content.context;
  let subtext = service.content.subtext;
  // let meta = service.meta;
</script>

<style></style>

<section id="services" class="py-4xl">
  <Container>
    <div class="fc jc ic md:flex-row">

      <div class="w-full md:w-4/6">
        <LgTextBlock data={context}></LgTextBlock>
  
        <div class="px-sm py-md sy-md max-w-xl">
          {#each context.items as item}
            <SmTextBlock data={item}></SmTextBlock>
          {/each}
        </div>
      </div>

      <div class="w-full md:w-2/6 fc md:text-center md:items-center px-sm py-xl sy-md">
        <div class="md:max-w-xs">
          <h5>{subtext.title}</h5>
        </div>
        <Grid>
          {#each subtext.items as item}
            <Logo logo={item}></Logo>
          {/each}
        </Grid>
      </div>

    </div>
  </Container>
</section>